import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const TextBox = ({ color, width, height, title, titleColor, text, textColor }) => {
  return (
    <Box
      sx={{
        backgroundColor: color,
        width: width,
        height: height,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center', // Centraliza o conteúdo na horizontal
        padding: '10px', // Padding para evitar cortes
        boxSizing: 'border-box', // Inclui padding na largura/altura total
        overflow: 'hidden', // Esconde o overflow caso o texto ainda corte
      }}
    >
      <Typography 
        variant="h6" 
        sx={{ 
          color: titleColor, 
          fontWeight: 'bold', // Define o texto como negrito
          textAlign: 'center', // Centraliza o texto
          fontSize: '1.50rem', // Aumenta o tamanho da fonte do título (exemplo: 1.25rem)
        }}
      >
        {title}
      </Typography>
      <Typography 
        variant="body2" 
        sx={{ 
          color: textColor, 
          textAlign: 'center', // Centraliza o texto
        }}
      >
        {text}
      </Typography>
      <Button 
  component={Link} 
  to="/contact" 
  sx={{
    fontWeight: 'bold', // Texto em negrito
    color: '#007BFF', // Cor inicial do texto
    textDecoration: 'none', // Remove sublinhado inicial
    transition: 'all 0.3s ease', // Adiciona transição suave
    '&:hover': {
      textDecoration: 'underline', // Adiciona sublinhado no hover
      transform: 'scale(1.05)', // Aumenta suavemente o tamanho da letra
    },
  }}
>
  Saiba mais
</Button>

    </Box>
  );
};

export default TextBox;
